const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
const englishRegex = /[a-zA-Z]/;
const numberRegex = /[0-9]/;

// 비밀번호 유효성 검사 함수
const passwordValid = (password: string): boolean => {
  if (!password || password.length < 8) return false;

  const hasSpecialChar = specialCharRegex.test(password);
  const hasEnglish = englishRegex.test(password);
  const hasNumber = numberRegex.test(password);

  return hasSpecialChar && hasEnglish && hasNumber;
};

export default passwordValid;